import * as React from 'react';
import { NavbarNavigation } from '../Navigation';
import { connect } from 'react-redux';
import { GlobalPrivateState } from 'src/api';
import { RouterState } from 'connected-react-router';
import { Navbar } from 'reactstrap';
import { LogoCentered } from '../Images';
import DashboardHeaderPartial from '../DashboardHeader/DashboardHeader';
import CloseHomeButton from '../CloseHomeButton/CloseHomeButton';

import './Header.scss';
import CloseProjectsButton from '../CloseHomeButton/CloseProjectsButton';

export interface HeaderProps {
  authenticator: GlobalPrivateState['authenticator'];
  configuration: GlobalPrivateState['configuration'];
  location: RouterState['location'];
  projects: GlobalPrivateState['project'];
  dashBoardTitle: GlobalPrivateState['titles']['dashboard'];
  userData: GlobalPrivateState['userData'];
  pricing: GlobalPrivateState['pricing'];
}

export class HeaderPartial extends React.Component<HeaderProps, any> {
  public render() {
    const { location } = this.props;

    return (
      <>
        <header className={`${this.showNavigation ? 'header position-fixed w-100' : 'header-configuration position-fixed w-100'}`}>
          <Navbar className="nav pt-5 pl-5 pr-5 pb-0">
            {this.showLogo && (
              <>
                {this.props.configuration && this.props.configuration.result && this.props.configuration.result.show2d ? (
                  <></>
                ) : (
                  <>
                    {location.pathname === '/' ? (
                      <LogoCentered withHome={false} />
                    ) : (
                      <LogoCentered />
                    )}
                    {this.props.dashBoardTitle && this.props.dashBoardTitle.title && (
                      <>
                        {!this.dontShowTitle && (
                          <DashboardHeaderPartial title={this.props.dashBoardTitle.title} />
                        )}
                      </>
                    )}
                  </>
                )}
              </>
            )}
            {this.showCloseButton && (
              <>
                {!this.projectsCloseButton && (
                  <CloseHomeButton />
                )}
                {this.projectsCloseButton && (
                  <CloseProjectsButton />
                )}
              </>
            )}
            {this.showNavigation && (
              <NavbarNavigation />
            )}
          </Navbar>
        </header>
      </>
    );
  }

  private get hasUserData(): boolean {
    const userData = this.props.userData.result;
    if (!userData || userData && !userData.validated) {
      return false;
    }
    return true;
  }

  private get isAuthenticated(): boolean {
    const { isAuthentificated } = this.props.authenticator;
    return isAuthentificated;
  }
  
  private get showNavigation(): boolean {
    if (!this.isAuthenticated || !this.hasUserData) {
      return false;
    }

    const { location } = this.props;
    const staticPaths = [
      '/',
      '/folders',
      '/profile/account',
      '/profile/projects',
      '/imprint',
      '/legals',
      '/privacy-policy',
      '/configuration',
      '/postcodes',
      '/pricings'
    ];
    
    const dynamicPaths = [
      /^\/pricings-accessories\/[^\/]+$/,
      /^\/pricings-washbasin\/[^\/]+$/,
      /^\/folders\/[^\/]+$/
    ];

    // Check if the location pathname is in the static paths array
    if (staticPaths.includes(location.pathname)) {
      return true;
    }

    // Check if the location pathname matches any of the dynamic path patterns
    for (const regex of dynamicPaths) {
      if (regex.test(location.pathname)) {
        return true;
      }
    }

    return false;
  }

  private get dontShowTitle(): boolean {
    const { location } = this.props;
    const staticPaths = [
      '/',
      '/folders',
      '/imprint',
      '/legals',
      '/privacy-policy',
      '/postcodes',
      '/pricings',
      '/troughs'
    ];
    
    const dynamicPaths = [
      /^\/pricings-accessories\/[^\/]+$/,
      /^\/pricings-washbasin\/[^\/]+$/,
      /^\/folders\/[^\/]+$/
    ];

    if (staticPaths.includes(location.pathname)) {
      return true;
    }

    for (const regex of dynamicPaths) {
      if (regex.test(location.pathname)) {
        return true;
      }
    }

    return false;
  }

  private get showCloseButton(): boolean {
    const { location } = this.props;

    const staticPaths = [
      '/configuration/new',
      '/profile/projects/new',
      '/troughs'
    ];
    
    const dynamicPaths = [
      /^\/configuration\/[^\/]+\/(project|rename|duplicate|delete|archive|unarchive)$/,
      /^\/profile\/projects\/[^\/]+\/(edit|delete)$/
    ];

    // Check if the location pathname is in the static paths array
    if (staticPaths.includes(location.pathname)) {
      return true;
    }

    // Check if the location pathname matches any of the dynamic path patterns
    for (const regex of dynamicPaths) {
      if (regex.test(location.pathname)) {
        return true;
      }
    }

    return false;
  }

  private get showLogo(): boolean {
    const { location } = this.props;

    const staticPaths = [
      '/configuration/new',
      '/profile/projects/new'
    ];
    
    const dynamicPaths = [
      /^\/configuration\/[^\/]+\/(project|rename|duplicate|delete|archive|unarchive)$/,
      /^\/profile\/projects\/[^\/]+\/(edit|delete)$/
    ];

    // Check if the location pathname is in the static paths array
    if (staticPaths.includes(location.pathname)) {
      return false;
    }

    // Check if the location pathname matches any of the dynamic path patterns
    for (const regex of dynamicPaths) {
      if (regex.test(location.pathname)) {
        return false;
      }
    }

    return true;
  }

  private get projectsCloseButton(): boolean {
    const { location } = this.props;

    const staticPaths = [
      '/profile/projects/new'
    ];
    
    const dynamicPaths = [
      /^\/profile\/projects\/[^\/]+\/(edit|delete|archive)$/
    ];

    // Check if the location pathname is in the static paths array
    if (staticPaths.includes(location.pathname)) {
      return true;
    }

    // Check if the location pathname matches any of the dynamic path patterns
    for (const regex of dynamicPaths) {
      if (regex.test(location.pathname)) {
        return true;
      }
    }

    return false;
  }
}

export const Header = connect((state: GlobalPrivateState) => ({
  authenticator: state.authenticator,
  configuration: state.configuration,
  location: state.router.location,
  projects: state.project,
  dashBoardTitle: state.titles.dashboard,
  userData: state.userData,
  pricing: state.pricing
}))(HeaderPartial);

export default Header;
